import React from "react";
import styled, { css, keyframes } from "styled-components";

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;
const scaleDown = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: scale(1);
     filter: blur(0);
     }
    100%{
      transform: scale(.9);
      filter: blur(15px);
    } 
`;
export const SettingsDiv = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  animation: ${(p) =>
    p.scaleDown
      ? css`
          ${scaleDown} 0.55s 1 forwards
        `
      : null};
  background-color: rgba(107, 102, 199, 0.85);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  && > div > div {
    margin-bottom: 45px;
  }
  && > div > h3 {
    font-size: 20px;
    margin-bottom: 45px;
    cursor: pointer;
  }
  && > div > label {
    margin-bottom: 45px;
    h3 {
      font-size: 20px;
      line-height: 36px;
    }
  }
`;
const Input = styled.input`
  & {
    background: none;

    -webkit-appearance: none;
    width: 160px;
    margin: 11.5px 0;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -11.5px;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #ffb205;
  }
  &::-moz-range-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-moz-range-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
  }
  &::-ms-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #faac00;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-fill-upper {
    background: #ffb000;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    height: 3px;
  }
  &:focus::-ms-fill-lower {
    background: #ffb000;
  }
  &:focus::-ms-fill-upper {
    background: #ffb205;
  }
`;

export const Volume = ({ saveUserSetting, value }) => {
  return (
    <label
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <h3
        style={{
          margin: "0",
          cursor: "pointer",
        }}
      >
        Volume
      </h3>
      <Input
        defaultValue={value}
        onMouseUp={(e) => saveUserSetting(e.target.value)}
        onTouchEnd={(e) => saveUserSetting(e.target.value)}
        type="range"
        max="1"
        min="0"
        step="0.1"
      />
    </label>
  );
};
